import { InputAdornment, TextField } from "@mui/material";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import { useState, useEffect } from "react";
import ConnectDomainModal from "../../../DomainIntregation/EndUserTypePermission/ConnectDomainModal";
import { websiteActionEndPointLogic } from "../../../../../../../logic/AssetManagement/Websites/websiteActionEndPointLogic";
import { CircularProgress } from "@mui/material";
import { CheckPermissions } from "../../../../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { useSelector } from "react-redux";
import {
  selectUserData,
  selectUserToken,
} from "../../../../../../../features/userSlice";
import { formatDate } from '../../../../../../../utils/helpers';

interface CreateWebsiteModalProps {
  additionalInfo: any;
  websiteList: any;
}

function WebsiteAdditionalInfo({
  additionalInfo,
  websiteList,
}: CreateWebsiteModalProps) {
  const response = useSelector(selectUserData);
  const [openNewWebsite, setopenNewWebsite] = useState(false);
  const [exists, setExists] = useState(false);
  const [domainRequests, setDomainRequests] = useState([]) as any;
  const [loading, setLoading] = useState(true);
  const hasDomainIntegrationPermission = CheckPermissions(
    response?.data?.products?.assets,
    "websites",
    "domain_integration_processing"
  );

  const oauthTokenHeader = useSelector(selectUserToken) as any;

  useEffect(() => {
    setLoading(true);
    websiteActionEndPointLogic
      .getDomainRequestsData(oauthTokenHeader, (data: any) => {
        setDomainRequests(data);
      })
      .then(() => setLoading(false));
  }, [oauthTokenHeader]);

  const handleOpenNewWebsite = () => {
    setopenNewWebsite(true);
  };

  const handleCloseNewWebsite = () => {
    setopenNewWebsite(false);
  };

  const handleDomainIntegrationRequest = (_: unknown, domainRequests: any) => {
    const requestExists = domainRequests.some(
      (request: any) => request.reference_id === additionalInfo?.site_url
    );
    setExists(requestExists);
  };

  return (
    <>
      <Grid container mt={2} spacing={2}>
        <Grid item xs={6}>
          <TextField
            id="standard-helperText"
            label="URL:"
            defaultValue={additionalInfo?.site_url}
            variant="standard"
            fullWidth
            color="secondary"
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            id="standard-helperText"
            label="Default Theme"
            defaultValue={additionalInfo?.default_theme}
            variant="standard"
            fullWidth
            color="secondary"
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            id="standard-helperText"
            label="Created by"
            defaultValue={additionalInfo?.created_by}
            variant="standard"
            fullWidth
            color="secondary"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Avatar
                    alt="Shay Yoash"
                    src="/path-to-avatar.jpg"
                    sx={{ width: 24, height: 24 }}
                  />
                </InputAdornment>
              ),
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            id="standard-helperText"
            label="Created on"
            defaultValue={formatDate(additionalInfo?.created)}
            variant="standard"
            fullWidth
            color="secondary"
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>
      </Grid>
      <Grid container mt={2} spacing={2}>
        <Grid item xs={6}>
          {loading ? (
            <CircularProgress size={24} color="secondary" />
          ) : hasDomainIntegrationPermission ? (
            exists ||
            domainRequests.some(
              (request: any) =>
                request.reference_id === additionalInfo?.site_url
            ) ? (
              <Button
                data-tracker="50"
                variant="contained"
                color="secondary"
                disabled
              >
                Pending Configuration
              </Button>
            ) : (
              <Button
                data-tracker="46"
                variant="contained"
                color="secondary"
                onClick={handleOpenNewWebsite}
                disabled={!additionalInfo?.site_url?.includes(".kinsta.cloud/")}
              >
                Connect a domain
              </Button>
            )
          ) : (
            <Button
              variant="contained"
              color="secondary"
              onClick={handleOpenNewWebsite}
              disabled
            >
              Connect a domain
            </Button>
          )}
        </Grid>
        <Grid item xs={3}>
          <TextField
            id="standard-helperText"
            label="G4 Property ID:"
            defaultValue={additionalInfo?.g4_property_id}
            variant="standard"
            fullWidth
            color="secondary"
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            id="standard-helperText"
            label="Finance ID:"
            defaultValue={additionalInfo?.finance_activity__name}
            variant="standard"
            fullWidth
            color="secondary"
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>
      </Grid>
      <ConnectDomainModal
        open={openNewWebsite}
        oauthTokenHeader={oauthTokenHeader}
        websiteList={websiteList}
        handleClose={handleCloseNewWebsite}
        onDomainIntegrationRequest={handleDomainIntegrationRequest}
        referenceURL={additionalInfo?.site_url}
        additionalInfo={additionalInfo}
      />
      {/* <DnsManagerMethodModal open={openNewWebsite} handleClose={handleCloseNewWebsite}/> */}
      {/* <DnsRecordMethodModal open={openNewWebsite} handleClose={handleCloseNewWebsite}/> */}
      {/* <DnsManagerDomainVerficationModal open={openNewWebsite} handleClose={handleCloseNewWebsite}/> */}
      {/* <DnsRecordDomainVerficationModal open={openNewWebsite} handleClose={handleCloseNewWebsite}/> */}
      {/* <DnsManagerDomainConnection open={openNewWebsite} handleClose={handleCloseNewWebsite}/> */}
      {/* <FinalNotificationModal open={openNewWebsite} handleClose={handleCloseNewWebsite}/> */}
      {/* <VerificationMethod open={openNewWebsite} handleClose={handleCloseNewWebsite}/> */}
    </>
  );
}

export default WebsiteAdditionalInfo;
